
import { defineComponent } from "vue";
import { CFooter, CLink } from "@coreui/vue";

export default defineComponent({
  name: "AppFooter",
  components: {
    CFooter,
    CLink,
  },
});
